import React, { useState, useMemo } from "react";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../../Context/AuthContext";
import _Button from "../../../components/generic/_Button";
import PropTypes from "prop-types";
import { ApiSMSEndpoint } from "../../../utils/ApiEndpoint";
import { useEncrypt } from "../hooks/useEncrypt";
import axios from "axios";
import { SuccessMessage, ErrorMessage } from "../../../utils/toastify";
import _ModalSendTestSMS from "./_ModalSendTestSMS";
import * as Yup from "yup";

const phoneSchema = Yup.string()
  .required("Por favor, ingrese un número de teléfono")
  .matches(/^[0-9]+$/, "Solo se permiten números")
  .length(10, "El número debe tener 10 dígitos");
const SendTestSMS = ({ messageWithTemplate = "" }) => {
  const auth = useAuth();
  const user = auth.getSessionData();
  const { getEncrypt } = useEncrypt();
  const [visible, setVisible] = useState({
    visible: false,
    data: false,
  });

  const [phone, setPhone] = useState(user?.vc_phone || "");
  const { mutate: sendSMS, isPending: isSending } = useMutation({
    mutationFn: async () => {
      const currentTime = Date.now();
      const data = {
        security: {
          partner_id: user.vc_partnerid,
          time: currentTime,
          hash: getEncrypt(user.vc_partnerid, currentTime, user.vc_secretkey),
        },
        notify: {
          service_id: user.vc_serviceid,
          number: phone,
          carrier: null,
          message: messageWithTemplate,
          xtraparams: {
            panelUserId: user.uid_user,
            source: "Panel",
          },
        },
      };

      const response = await axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        url: ApiSMSEndpoint,
        data: data,
      });

      return response.data;
    },
    onSuccess: (data) => {
      if (data.result.code !== "0") {
        ErrorMessage("Error al enviar el SMS de prueba");
        return;
      }
      setVisible({ visible: false, data: false });
      SuccessMessage("SMS de prueba enviado con éxito");
    },
    onError: () => {
      ErrorMessage("Error al enviar el SMS de prueba");
    },
  });

  if (!user.vc_phone || ![2, 3].includes(user?.id_usertype)) return null;

  const { isError, errorMsg } = useMemo(() => {
    try {
      phoneSchema.validateSync(phone);
      return { isError: false, errorMsg: "" };
    } catch (err) {
      return { isError: true, errorMsg: err.message };
    }
  }, [phone]);

  const validatePhone = () => {
    try {
      phoneSchema.validateSync(phone);
      return true;
    } catch (err) {
      return false;
    }
  };

  return (
    <div className="w-full my-2 flex justify-center">
      <_Button
        style="outline"
        disabled={!messageWithTemplate}
        onClick={() => setVisible({ visible: true, data: messageWithTemplate })}
        title="Enviar SMS de prueba"
        className="w-full"
      />

      <_ModalSendTestSMS
        visible={visible.visible}
        onClose={() => setVisible({ visible: false, data: false })}
        title="Enviar SMS de prueba"
        data={visible.data}
        onAction={() => {
          if (!validatePhone()) {
            ErrorMessage("Por favor, ingrese un número de teléfono");
            return;
          }
          sendSMS();
        }}
        defaultData={phone}
        onHandlePhone={(e) => setPhone(e.target.value)}
        isLoading={isSending}
        isError={isError}
        errorMsg={errorMsg}
      />
    </div>
  );
};

SendTestSMS.propTypes = {
  messageWithTemplate: PropTypes.string,
};

export default SendTestSMS;
